/**
 * 云端新建弹窗：编辑保存后合并子类草稿菜品行。
 */
import type { MenuDish } from '../models';
import type { PatchDishesParams } from '../request/api/rbp/menu';

/** 合并参数：旧行 + 表单 payload + 显式覆盖字段 */
export type MergeCloudCreateDialogDishRowAfterUpdateParams = {
    /** 编辑前草稿行（可无） */
    existingDish: MenuDish | undefined;
    /** 表单组装的写字段 */
    payload: PatchDishesParams;
    /** 保存后菜品图文件名 */
    dishImageFinal: string;
    /** 过敏原 key 列表 */
    allergenKeys: string[];
    /** 成分 key 列表 */
    ingredientKeys: string[];
    /** 云端菜品 string id */
    cloudDishId: string;
    /** 套餐组快照（可选；非套餐可不传） */
    courseGroups?: unknown;
};

/**
 * 云端新建弹窗编辑保存成功后合并草稿菜品行。
 * 须先铺旧行再铺表单 payload，否则旧字段会盖住修改后的名称/价格等。
 * @param params - 合并入参
 * @returns 写回子类草稿列表的菜品行
 */
export function mergeCloudCreateDialogDishRowAfterUpdate(
    params: MergeCloudCreateDialogDishRowAfterUpdateParams,
): MenuDish {
    const {
        existingDish,
        payload,
        dishImageFinal,
        allergenKeys,
        ingredientKeys,
        cloudDishId,
        courseGroups,
    } = params;
    /** 先旧行再 payload，保证名称/价格等取自本次表单（`...undefined` 无副作用） */
    return {
        ...existingDish,
        ...payload,
        item_id: existingDish?.item_id,
        dish_image: dishImageFinal,
        allergen: allergenKeys,
        other_detail_info: ingredientKeys,
        id: cloudDishId,
        not_joining_global_limit: Number(existingDish?.not_joining_global_limit ?? 0) || 0,
        ...(courseGroups !== undefined ? { course_groups: courseGroups } : {}),
    } as unknown as MenuDish;
}
